function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="80" fill="none" viewBox="0 0 110 80">
      <path
        fill="#0044F0"
        d="M54.745 52.7c-17.25 0-31.805 2.818-31.805 13.697C22.94 77.28 37.59 80 54.745 80c17.25 0 31.805-2.819 31.805-13.697C86.55 55.419 71.9 52.7 54.745 52.7z"
      ></path>
      <path
        fill="#0044F0"
        d="M54.745 42.335c11.68 0 21.047-9.42 21.047-21.167C75.792 9.415 66.426 0 54.745 0 43.065 0 33.7 9.415 33.7 21.168c0 11.747 9.366 21.167 21.046 21.167zM100.44 26.096c3.022-11.887-5.838-22.563-17.12-22.563-1.227 0-2.4.135-3.546.365-.152.036-.322.112-.412.247-.103.171-.027.401.085.55 3.39 4.782 5.337 10.604 5.337 16.854 0 5.988-1.787 11.572-4.92 16.205-.323.477-.036 1.121.532 1.22.788.14 1.594.212 2.418.234 8.215.217 15.589-5.101 17.626-13.112z"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M109.047 54.085c-1.505-3.224-5.136-5.435-10.656-6.52-2.605-.64-9.657-1.54-16.216-1.419-.098.014-.152.081-.16.126-.014.063.013.171.143.239 3.03 1.508 14.747 8.069 13.274 21.906-.063.599.416 1.117 1.012 1.027 2.883-.415 10.301-2.018 12.603-7.011a9.615 9.615 0 000-8.348z"
      ></path>
      <path
        fill="#0044F0"
        d="M30.224 3.899a17.571 17.571 0 00-3.546-.365c-11.282 0-20.142 10.676-17.116 22.564 2.033 8.01 9.407 13.328 17.622 13.112.824-.023 1.634-.1 2.418-.234.568-.1.855-.743.532-1.22-3.134-4.639-4.92-10.218-4.92-16.206 0-6.255 1.952-12.077 5.341-16.854.108-.149.188-.378.08-.55-.089-.139-.254-.211-.411-.247z"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M11.608 47.563C6.088 48.648 2.46 50.86.957 54.083a9.592 9.592 0 000 8.353c2.301 4.99 9.72 6.597 12.603 7.006.595.09 1.07-.423 1.007-1.026-1.473-13.833 10.244-20.393 13.279-21.902.125-.072.152-.175.139-.243-.01-.045-.058-.113-.157-.121-6.563-.127-13.61.774-16.22 1.413z"
      ></path>
    </svg>
  );
}

export default Icon;
